import React, { FC } from 'react';

import { IconPropsExtended } from '../types';

import MaterialSymbolIconBase from './MaterialSymbolIconBase';

/**
 * Material symbol Remove icon
 *
 * @param props Props passed to the component
 * @returns     Remove icon
 */
const MaterialSymbolRemoveIcon: FC<IconPropsExtended> = props => (
  <MaterialSymbolIconBase {...props} iconName="remove" />
);

export default MaterialSymbolRemoveIcon;
